import './index.scss';
import { dataCompany } from 'data/company';

/**
 * 시공사(시행사) 정보를 표출하는 컴포넌트.
 * Footer 바로 위에 표출됩니다.
 */
const CompanyInfo = () => {
  return (
    <>
      <div className="footer-detail-company">
        <div className="footer-detail-company-container">
          {
            dataCompany.map((value, idx) => {
              return (
                <div key={idx} className="footer-detail-company-items">
                  <span> { value.title } </span>
                  <span className="detail"> { value.desc } </span>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  );
};

export default CompanyInfo;